/**
 * Pequemimo product image lightbox. Tapping any gallery photo (including the
 * main one) opens a fullscreen viewer with horizontal swipe between photos
 * and pinch/double-tap zoom. Pointer Events drive everything by hand (no
 * native scroll-snap) so panning a zoomed photo doesn't fight the swipe
 * gesture.
 */
(function () {
  var lightbox = document.getElementById('ProductLightbox');
  if (!lightbox) return;

  var track = lightbox.querySelector('[data-lightbox-track]');
  var slides = Array.prototype.slice.call(lightbox.querySelectorAll('[data-lightbox-slide]'));
  var countEl = lightbox.querySelector('[data-lightbox-count]');
  var triggers = Array.prototype.slice.call(document.querySelectorAll('[data-gallery-trigger]'));
  if (!track || !slides.length) return;

  var MIN_SCALE = 1;
  var MAX_SCALE = 4;
  var TAP_ZOOM_SCALE = 2.5;
  var SWIPE_THRESHOLD_RATIO = 0.18;
  var WHEEL_SENSITIVITY = 0.0018;
  var BUTTON_ZOOM_FACTOR = 1.6;

  var currentIndex = 0;
  var lastTrigger = null;
  var pointers = {}; // pointerId -> {x, y}
  var mode = null; // 'swipe' | 'pan' | 'pinch'
  var lastPointerType = 'touch';
  var slideWidth = 0;
  var slideHeight = 0;

  // Per-slide zoom state.
  var zoomState = slides.map(function () {
    return { scale: 1, panX: 0, panY: 0 };
  });

  var dragStartX = 0;
  var dragStartY = 0;
  var dragDeltaX = 0;
  var pinchStartDistance = 0;
  var pinchStartScale = 1;
  var pinchStartPanX = 0;
  var pinchStartPanY = 0;
  var pinchMidX = 0;
  var pinchMidY = 0;
  var lastTapTime = 0;
  var lastTapX = 0;
  var lastTapY = 0;

  function clamp(value, min, max) {
    return Math.max(min, Math.min(max, value));
  }

  function currentZoomEl() {
    return slides[currentIndex].querySelector('[data-lightbox-zoom]');
  }

  function applyZoom(index, animate) {
    var el = slides[index].querySelector('[data-lightbox-zoom]');
    if (!el) return;
    var state = zoomState[index];
    el.classList.toggle('is-animating', !!animate);
    el.style.transform = 'translate3d(' + state.panX + 'px, ' + state.panY + 'px, 0) scale(' + state.scale + ')';
    if (index === currentIndex) el.classList.toggle('is-zoomed', state.scale > 1.001);
  }

  // Recomputes pan so the viewport point (x, y) stays anchored while scaling
  // the current slide to newScale. Used by wheel zoom, the +/- buttons and
  // click/tap-to-zoom — anything that sets an absolute target scale.
  function zoomAround(x, y, newScale, animate) {
    var state = zoomState[currentIndex];
    newScale = clamp(newScale, MIN_SCALE, MAX_SCALE);
    var scaleRatio = newScale / state.scale;
    var rect = slides[currentIndex].getBoundingClientRect();
    var offsetX = x - (rect.left + slideWidth / 2);
    var offsetY = y - (rect.top + slideHeight / 2);
    state.scale = newScale;
    state.panX = state.panX + offsetX * (1 - scaleRatio);
    state.panY = state.panY + offsetY * (1 - scaleRatio);
    clampPan(currentIndex);
    applyZoom(currentIndex, animate);
  }

  function toggleZoomAt(x, y) {
    var state = zoomState[currentIndex];
    if (state.scale > 1) {
      resetZoom(currentIndex, true);
    } else {
      zoomAround(x, y, TAP_ZOOM_SCALE, true);
    }
  }

  function stepZoom(factor) {
    var rect = slides[currentIndex].getBoundingClientRect();
    zoomAround(rect.left + slideWidth / 2, rect.top + slideHeight / 2, zoomState[currentIndex].scale * factor, true);
  }

  function resetZoom(index, animate) {
    zoomState[index].scale = 1;
    zoomState[index].panX = 0;
    zoomState[index].panY = 0;
    applyZoom(index, animate);
  }

  function clampPan(index) {
    var state = zoomState[index];
    var maxX = Math.max(0, (state.scale - 1) * slideWidth * 0.5);
    var maxY = Math.max(0, (state.scale - 1) * slideHeight * 0.5);
    state.panX = clamp(state.panX, -maxX, maxX);
    state.panY = clamp(state.panY, -maxY, maxY);
  }

  function setTrackPosition(animate, extraPx) {
    var basePercent = -currentIndex * 100;
    track.classList.toggle('is-animating', !!animate);
    var offset = extraPx ? ' + ' + extraPx + 'px' : '';
    track.style.transform = 'translate3d(calc(' + basePercent + '%' + offset + '), 0, 0)';
  }

  function updateCount() {
    if (countEl) countEl.textContent = (currentIndex + 1) + ' / ' + slides.length;
  }

  function measure() {
    var rect = lightbox.getBoundingClientRect();
    slideWidth = rect.width;
    slideHeight = rect.height;
  }

  function goTo(index, animate) {
    index = clamp(index, 0, slides.length - 1);
    if (index !== currentIndex) resetZoom(index, false);
    currentIndex = index;
    setTrackPosition(animate);
    updateCount();
  }

  function open(index) {
    lastTrigger = document.activeElement;
    lightbox.hidden = false;
    lightbox.setAttribute('aria-hidden', 'false');
    // Force layout before adding the open class so nothing transitions in.
    // eslint-disable-next-line no-unused-expressions
    lightbox.offsetHeight;
    lightbox.classList.add('is-open');
    document.body.classList.add('cart-open');
    measure();
    goTo(index, false);
    var closeBtn = lightbox.querySelector('[data-lightbox-close]');
    if (closeBtn) closeBtn.focus();
    document.addEventListener('keydown', onKeydown);
  }

  function close() {
    lightbox.classList.remove('is-open');
    lightbox.setAttribute('aria-hidden', 'true');
    lightbox.hidden = true;
    document.body.classList.remove('cart-open');
    document.removeEventListener('keydown', onKeydown);
    slides.forEach(function (slide, i) {
      resetZoom(i, false);
    });
    if (lastTrigger && typeof lastTrigger.focus === 'function') lastTrigger.focus();
  }

  function onKeydown(e) {
    if (e.key === 'Escape') close();
    else if (e.key === 'ArrowRight') goTo(currentIndex + 1, true);
    else if (e.key === 'ArrowLeft') goTo(currentIndex - 1, true);
  }

  function pointerCount() {
    return Object.keys(pointers).length;
  }

  function distance(a, b) {
    return Math.hypot(a.x - b.x, a.y - b.y);
  }

  function midpoint(a, b) {
    return { x: (a.x + b.x) / 2, y: (a.y + b.y) / 2 };
  }

  function pointerList() {
    return Object.keys(pointers).map(function (id) {
      return pointers[id];
    });
  }

  function onPointerDown(e) {
    if (!lightbox.classList.contains('is-open')) return;
    try {
      track.setPointerCapture(e.pointerId);
    } catch (err) {
      /* ignore: some browsers reject capture for already-released or synthetic pointers */
    }
    pointers[e.pointerId] = { x: e.clientX, y: e.clientY };

    var count = pointerCount();
    if (count === 1) {
      lastPointerType = e.pointerType;
      dragStartX = e.clientX;
      dragStartY = e.clientY;
      dragDeltaX = 0;
      var state = zoomState[currentIndex];
      pinchStartPanX = state.panX;
      pinchStartPanY = state.panY;
      mode = state.scale > 1 ? 'pan' : 'swipe';
      track.classList.remove('is-animating');
    } else if (count === 2) {
      var pts = pointerList();
      pinchStartDistance = distance(pts[0], pts[1]);
      var mid = midpoint(pts[0], pts[1]);
      pinchMidX = mid.x;
      pinchMidY = mid.y;
      pinchStartScale = zoomState[currentIndex].scale;
      pinchStartPanX = zoomState[currentIndex].panX;
      pinchStartPanY = zoomState[currentIndex].panY;
      mode = 'pinch';
      currentZoomEl().classList.remove('is-animating');
    }
  }

  function onPointerMove(e) {
    if (!pointers[e.pointerId]) return;
    pointers[e.pointerId] = { x: e.clientX, y: e.clientY };

    if (mode === 'pinch' && pointerCount() === 2) {
      var pts = pointerList();
      var dist = distance(pts[0], pts[1]);
      var ratio = dist / pinchStartDistance;
      var newScale = clamp(pinchStartScale * ratio, MIN_SCALE, MAX_SCALE);
      var scaleRatio = newScale / pinchStartScale;
      var slideCenterX = slideWidth / 2;
      var slideCenterY = slideHeight / 2;
      var offsetX = pinchMidX - (slides[currentIndex].getBoundingClientRect().left + slideCenterX);
      var offsetY = pinchMidY - (slides[currentIndex].getBoundingClientRect().top + slideCenterY);

      var state = zoomState[currentIndex];
      state.scale = newScale;
      state.panX = pinchStartPanX + offsetX * (1 - scaleRatio);
      state.panY = pinchStartPanY + offsetY * (1 - scaleRatio);
      clampPan(currentIndex);
      applyZoom(currentIndex, false);
    } else if (mode === 'pan') {
      var dx = e.clientX - dragStartX;
      var dy = e.clientY - dragStartY;
      var st = zoomState[currentIndex];
      st.panX = pinchStartPanX + dx;
      st.panY = pinchStartPanY + dy;
      clampPan(currentIndex);
      applyZoom(currentIndex, false);
    } else if (mode === 'swipe') {
      dragDeltaX = e.clientX - dragStartX;
      var dyAbs = Math.abs(e.clientY - dragStartY);
      if (Math.abs(dragDeltaX) < dyAbs) return;
      setTrackPosition(false, dragDeltaX);
    }
  }

  function onPointerUp(e) {
    if (!pointers[e.pointerId]) return;
    delete pointers[e.pointerId];

    if (mode === 'swipe' && pointerCount() === 0) {
      if (!maybeHandleTap(e)) {
        var threshold = slideWidth * SWIPE_THRESHOLD_RATIO;
        if (dragDeltaX <= -threshold && currentIndex < slides.length - 1) {
          goTo(currentIndex + 1, true);
        } else if (dragDeltaX >= threshold && currentIndex > 0) {
          goTo(currentIndex - 1, true);
        } else {
          setTrackPosition(true);
        }
      }
      mode = null;
    } else if (mode === 'pinch' && pointerCount() < 2) {
      if (pointerCount() === 1) {
        var remaining = pointerList()[0];
        dragStartX = remaining.x;
        dragStartY = remaining.y;
        var st = zoomState[currentIndex];
        pinchStartPanX = st.panX;
        pinchStartPanY = st.panY;
        mode = st.scale > 1 ? 'pan' : 'swipe';
      } else {
        settleZoom();
        mode = null;
      }
    } else if (mode === 'pan' && pointerCount() === 0) {
      if (!maybeHandleTap(e)) settleZoom();
      mode = null;
    }
  }

  function settleZoom() {
    var state = zoomState[currentIndex];
    if (state.scale < MIN_SCALE + 0.02) {
      resetZoom(currentIndex, true);
    } else {
      clampPan(currentIndex);
      applyZoom(currentIndex, true);
    }
  }

  // Returns true if this pointer-up was a tap/click that toggled zoom (so the
  // caller should skip its own swipe-snap / pan-settle handling). Mouse users
  // get a single click to zoom in and out; touch keeps the double-tap
  // convention so a normal single tap doesn't fight the swipe gesture.
  function maybeHandleTap(e) {
    var dx = e.clientX - dragStartX;
    var dy = e.clientY - dragStartY;
    if (Math.hypot(dx, dy) > 8) return false;

    if (lastPointerType === 'mouse') {
      toggleZoomAt(e.clientX, e.clientY);
      return true;
    }

    var now = Date.now();
    var tdx = Math.abs(e.clientX - lastTapX);
    var tdy = Math.abs(e.clientY - lastTapY);
    if (now - lastTapTime < 300 && tdx < 30 && tdy < 30) {
      toggleZoomAt(e.clientX, e.clientY);
      lastTapTime = 0;
      return true;
    }
    lastTapTime = now;
    lastTapX = e.clientX;
    lastTapY = e.clientY;
    return false;
  }

  function onPointerCancel(e) {
    if (pointers[e.pointerId]) delete pointers[e.pointerId];
    if (pointerCount() === 0) {
      mode = null;
      setTrackPosition(true);
    }
  }

  // Desktop: mouse-wheel / trackpad zoom, anchored under the cursor.
  function onWheel(e) {
    if (!lightbox.classList.contains('is-open')) return;
    e.preventDefault();
    var factor = Math.exp(-e.deltaY * WHEEL_SENSITIVITY);
    zoomAround(e.clientX, e.clientY, zoomState[currentIndex].scale * factor, false);
  }

  track.addEventListener('pointerdown', onPointerDown);
  track.addEventListener('pointermove', onPointerMove);
  track.addEventListener('pointerup', onPointerUp);
  track.addEventListener('pointercancel', onPointerCancel);
  track.addEventListener('wheel', onWheel, { passive: false });

  // Safari (desktop) reports trackpad pinch as proprietary gesture events,
  // not 'wheel'. Left alone, a trackpad pinch zooms the whole page/viewport
  // (including our fixed close button/counter) instead of our own zoom, and
  // panning while natively zoomed inside a fixed fullscreen layer gets stuck.
  // Suppress it while the lightbox is open so our pinch/wheel/click zoom is
  // the only thing that responds.
  function preventNativeGesture(e) {
    if (lightbox.classList.contains('is-open')) e.preventDefault();
  }
  document.addEventListener('gesturestart', preventNativeGesture);
  document.addEventListener('gesturechange', preventNativeGesture);
  document.addEventListener('gestureend', preventNativeGesture);

  window.addEventListener('resize', function () {
    if (lightbox.classList.contains('is-open')) measure();
  });

  triggers.forEach(function (trigger) {
    trigger.addEventListener('click', function () {
      var index = parseInt(trigger.getAttribute('data-index'), 10) || 0;
      open(index);
    });
    trigger.addEventListener('keydown', function (e) {
      if (e.key === 'Enter' || e.key === ' ') {
        e.preventDefault();
        var index = parseInt(trigger.getAttribute('data-index'), 10) || 0;
        open(index);
      }
    });
  });

  lightbox.querySelectorAll('[data-lightbox-close]').forEach(function (btn) {
    btn.addEventListener('click', close);
  });

  var zoomInBtn = lightbox.querySelector('[data-lightbox-zoom-in]');
  var zoomOutBtn = lightbox.querySelector('[data-lightbox-zoom-out]');
  if (zoomInBtn) zoomInBtn.addEventListener('click', function () { stepZoom(BUTTON_ZOOM_FACTOR); });
  if (zoomOutBtn) zoomOutBtn.addEventListener('click', function () { stepZoom(1 / BUTTON_ZOOM_FACTOR); });
})();
